import { useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { VatExemptionMentionModal } from '@features/invoicingSettings/elements/VatExemptionMentionModal'
import { useUpdateVatExemptionMention } from '@features/invoicingSettings/hooks/useUpdateVatExemptionMention'
import { useZervantSettings } from '@features/invoicingSettings/hooks/useZervantSettings'

import { ModalId } from '../../../../../../enums/modalId'
import { VatExemptionMentionInfoModal } from '../VatExemptionMentionInfoModal'

export const InvoiceEditorVatExemptionModals = (): ReactElement => {
  const { data: zervantSettings } = useZervantSettings()
  const { close: closeVatExemptionMentionModal } = useModal(ModalId.VatExemptionMentionModal)
  const {
    update: updateVatExemptionMention,
    isProcessing: isUpdatingVatExemptionMention,
    isLoading: isLoadingZervantSettings,
  } = useUpdateVatExemptionMention()

  const vatExemptionMentionScheme = zervantSettings?.values?.company?.legalMentions?.custom?.vatExemptionScheme ?? ''

  const handleVatExemptionMentionModalSubmit = useCallback(
    (value: string) => {
      updateVatExemptionMention(value, closeVatExemptionMentionModal)
    },
    [closeVatExemptionMentionModal, updateVatExemptionMention],
  )

  return (
    <>
      <VatExemptionMentionModal
        defaultValue={vatExemptionMentionScheme}
        id={ModalId.VatExemptionMentionModal}
        isSubmitting={isUpdatingVatExemptionMention || isLoadingZervantSettings}
        onSubmit={handleVatExemptionMentionModalSubmit}
      />
      <VatExemptionMentionInfoModal id={ModalId.VatExemptionMentionInfoModal} />
    </>
  )
}
